<div class="modal-header">
  <h2 class="capitalize" mat-dialog-title>
    <span trans *ngIf="!data.linkGroup">Create {{ resourceName }}</span>
    <span trans *ngIf="data.linkGroup">Update {{ resourceName }}</span>
  </h2>
  <button type="button" (click)="close()" class="close-button no-style" tabindex="-1">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<form (ngSubmit)="confirm()" ngNativeValidate [formGroup]="form" *ngIf="errors$ | async as errors">
  <mat-dialog-content class="many-inputs">
    <div class="input-container name-container">
      <label for="link-group-name" trans>Name</label>
      <input type="text" id="link-group-name" formControlName="name" required minlength="3" />
      <div class="error" *ngIf="errors.name">{{ errors.name }}</div>
    </div>

    <div class="input-container">
      <slug-control [baseUri]="slugBaseUri$ | async" formControlName="hash"></slug-control>
      <div class="error" *ngIf="errors.hash">{{ errors.hash }}</div>
    </div>

    <domain-form-control
      controlName="domain_id"
      [domains]="domains$ | async"
      class="many-inputs"
    ></domain-form-control>

    <div class="input-container">
      <label for="link-group-description" trans>Description</label>
      <textarea id="link-group-description" formControlName="description"></textarea>
    </div>

    <div class="setting-toggle-container">
      <mat-slide-toggle class="capitalize" formControlName="active" id="link-group-active" trans
        >Active</mat-slide-toggle
      >
      <p trans>Whether this {{ resourceName }} is viewable publicly.</p>
    </div>

    <div class="setting-toggle-container" *ngIf="data.type !== 'biolink'">
      <mat-slide-toggle formControlName="rotator" id="link-group-rotator" trans
        >Rotator</mat-slide-toggle
      >
      <p trans>
        When checked, url above will redirect to random link from the group, instead of showing all
        links belonging to group.
      </p>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button (click)="close()" type="button" mat-button trans>Cancel</button>
    <button type="submit" mat-raised-button color="accent" [disabled]="loading$ | async" trans>
      <span *ngIf="updating$ | async; else creating">Update</span>
      <ng-template #creating>
        <span>Create</span>
      </ng-template>
    </button>
  </mat-dialog-actions>
</form>
